module.exports = __webpack_public_path__ + "img/Flash sale 1@3x.png";